<template>
    <Paper :header="$t('spotlight.communication.header')" tall>
        <CommunicationSkeleton v-if="isLoading" />
        <div v-else class="p-4">
            <BaseCheckbox :value="value" @input="onConsentChange">
                {{ $t('spotlight.communication.sendMeUpdatesDescription') }}
            </BaseCheckbox>
            <!-- <b-collapse :visible='value' id='newsletter-consent-group'>
                <div class='mt-2'>
                    <h6>Email limit:</h6>
                    <div class="btn-group btn-group-sm" role="group">
                        <BaseButton variant='primary'>Left</BaseButton>
                        <BaseButton variant='primary'>Middle</BaseButton>
                        <BaseButton variant='primary'>Right</BaseButton>
                    </div>
                </div>
            </b-collapse> -->
        </div>
    </Paper>
</template>

<script>
import CommunicationSkeleton from '../skeletons/CommunicationSkeleton';

export default {
    name: 'Communication',
    components: { CommunicationSkeleton },
    props: {
        value: Boolean,
        maxLimit: String,
        isLoading: Boolean,
    },
    data: () => ({}),
    methods: {
        emitUpdate(value) {
            this.$emit('input', value);
        },
        onConsentChange(value) {
            this.emitUpdate(value);
        },
    },
};
</script>

<style scoped></style>
